export const APP_ENV = process.env.REACT_APP_APP_ENV || 'development'
export const ENDPOINT = 'https://api.graph.cool/simple/v1/cogsworth'
export const DEFAULT_SERVICE_LEADTIME = 0
export const DEFAULT_SERVICE_TIME_INCREMENT = 10
export const DEFAULT_BUSINESS_AVAILABILITY_LIMIT_DAYS = 90

export const STRIPE_PLAN_PRO_ID = 'pro'
export const STRIPE_PLAN_STAFF_PACK_ID = '5-staff-pack'
export const STRIPE_PLAN_ADDITIONAL_BUSINESS_ID = 'additional-business'
export const SUBSCRIPTION_ACTIVE_STATUSES = ["trialing", "active", "past_due"]
export const SUBSCRIPTION_UNACTIVE_STATUSES = ["canceled", "unpaid"]

export const BUGSNAG_API_KEY = process.env.REACT_APP_BUGSNAG_API_KEY
export const BUGSNAG_ENABLED = process.env.REACT_APP_BUGSNAG_ENABLED

export const CURRENCIES = {
  'AED': { symbol: 'د.إ', exponent: 2 },
  'AFN': { symbol: '؋', exponent: 2 },
  'ALL': { symbol: 'Lek', exponent: 2 },
  'ANG': { symbol: 'ƒ', exponent: 2 },
  'ARS': { symbol: '$', exponent: 2 },
  'ATS': { symbol: 'öS', exponent: 2 },
  'AUD': { symbol: '$', exponent: 2 },
  'BBD': { symbol: '$', exponent: 2 },
  'BDT': { symbol: '৳', exponent: 2 },
  'BGN': { symbol: 'Лв.', exponent: 2 },
  'BHD': { symbol: 'BD', exponent: 3 },
  'BRL': { symbol: 'R$', exponent: 2 },
  'BMD': { symbol: '$', exponent: 2 },
  'BSD': { symbol: '$', exponent: 2 },
  'CAD': { symbol: '$', exponent: 2 },
  'CHF': { symbol: 'Fr.', exponent: 2 },
  'CLP': { symbol: '$', exponent: 0 },
  'CNY': { symbol: '¥', exponent: 2 },
  'COP': { symbol: '$', exponent: 2 },
  'CRC': { symbol: '₡', exponent: 2 },
  'CZK': { symbol: 'Kč', exponent: 2 },
  'DKK': { symbol: 'kr', exponent: 2 },
  'DOP': { symbol: 'RD$', exponent: 2 },
  'DZD': { symbol: 'دج', exponent: 2 },
  'EGP': { symbol: '£', exponent: 2 },
  'EUR': { symbol: '€', exponent: 2 },
  'FIM': { symbol: 'mk', exponent: 2 },
  'FJD': { symbol: '$', exponent: 2 },
  'GBP': { symbol: '£', exponent: 2 },
  'GTQ': { symbol: 'Q', exponent: 2 },
  'HKD': { symbol: '$', exponent: 2 },
  'HRK': { symbol: 'kn', exponent: 2 },
  'HUF': { symbol: 'Ft', exponent: 2 },
  'IDR': { symbol: 'Rp', exponent: 2 },
  'ILS': { symbol: '₪', exponent: 2 },
  'INR': { symbol: '₹', exponent: 2 },
  'IQD': { symbol: 'ع.د', exponent: 3 },
  'IRR': { symbol: '﷼', exponent: 2 },
  'ISK': { symbol: 'kr', exponent: 0 },
  'JMD': { symbol: 'J$', exponent: 2 },
  'JOD': { symbol: 'د.ا', exponent: 3 },
  'JPY': { symbol: '¥', exponent: 0 },
  'KES': { symbol: 'Ksh', exponent: 2 },
  'KRW': { symbol: '₩', exponent: 0 },
  'KWD': { symbol: 'KD', exponent: 3 },
  'LBP': { symbol: '£', exponent: 2 },
  'LKR': { symbol: '₨', exponent: 2 },
  'MAD': { symbol: 'DH', exponent: 2 },
  'MUR': { symbol: '₨', exponent: 2 },
  'MXN': { symbol: '$', exponent: 2 },
  'MYR': { symbol: 'RM', exponent: 2 },
  'NOK': { symbol: 'kr', exponent: 2 },
  'NZD': { symbol: '$', exponent: 2 },
  'OMR': { symbol: '﷼', exponent: 3 },
  'PEN': { symbol: 'S/.', exponent: 2 },
  'PHP': { symbol: '₱', exponent: 2 },
  'PKR': { symbol: '₨', exponent: 2 },
  'PLN': { symbol: 'zł', exponent: 2 },
  'QAR': { symbol: '﷼', exponent: 2 },
  'RON': { symbol: 'lei', exponent: 2 },
  'RUB': { symbol: '₽', exponent: 2 },
  'SAR': { symbol: '﷼', exponent: 2 },
  'SDD': { symbol: 'LSd', exponent: 2 },
  'SEK': { symbol: 'kr', exponent: 2 },
  'SGD': { symbol: '$', exponent: 2 },
  'SKK': { symbol: 'Sk', exponent: 2 },
  'THB': { symbol: '฿', exponent: 2 },
  'TND': { symbol: 'DT', exponent: 3 },
  'TTD': { symbol: 'TT$', exponent: 2 },
  'TWD': { symbol: 'NT$', exponent: 2 },
  'TRY': { symbol: '₺', exponent: 2 },
  'USD': { symbol: '$', exponent: 2 },
  'UYU': { symbol: '$U', exponent: 2 },
  'VEB': { symbol: 'Bs.', exponent: 2 },
  'VND': { symbol: '₫', exponent: 0 },
  'XAF': { symbol: 'XAF', exponent: 0 },
  'XCD': { symbol: '$', exponent: 2 },
  'XOF': { symbol: 'XOF', exponent: 0 },
  'XPF': { symbol: '₣', exponent: 0 },
  'ZAR': { symbol: 'R', exponent: 2 },
  'ZMK': { symbol: 'ZK', exponent: 2 },
}

export const TIMEZONES_COUNTRIES = {
  "Africa/Abidjan": "CI",
  "Africa/Accra": "GH",
  "Africa/Addis_Ababa": "ET",
  "Africa/Algiers": "DZ",
  "Africa/Asmara": "ER",
  "Africa/Asmera": "ER",
  "Africa/Bamako": "ML",
  "Africa/Bangui": "CF",
  "Africa/Banjul": "GM",
  "Africa/Bissau": "GW",
  "Africa/Blantyre": "MW",
  "Africa/Brazzaville": "CG",
  "Africa/Bujumbura": "BI",
  "Africa/Cairo": "EG",
  "Africa/Casablanca": "EH",
  "Africa/Ceuta": "ES",
  "Africa/Conakry": "GN",
  "Africa/Dakar": "SN",
  "Africa/Dar_es_Salaam": "TZ",
  "Africa/Djibouti": "DJ",
  "Africa/Douala": "CM",
  "Africa/El_Aaiun": "EH",
  "Africa/Freetown": "SL",
  "Africa/Gaborone": "BW",
  "Africa/Harare": "ZW",
  "Africa/Johannesburg": "ZA",
  "Africa/Juba": "SS",
  "Africa/Kampala": "UG",
  "Africa/Khartoum": "SD",
  "Africa/Kigali": "RW",
  "Africa/Kinshasa": "CD",
  "Africa/Lagos": "NG",
  "Africa/Libreville": "GA",
  "Africa/Lome": "TG",
  "Africa/Luanda": "AO",
  "Africa/Lubumbashi": "CD",
  "Africa/Lusaka": "ZM",
  "Africa/Malabo": "GQ",
  "Africa/Maputo": "MZ",
  "Africa/Maseru": "LS",
  "Africa/Mbabane": "SZ",
  "Africa/Mogadishu": "SO",
  "Africa/Monrovia": "LR",
  "Africa/Nairobi": "KE",
  "Africa/Ndjamena": "TD",
  "Africa/Niamey": "NE",
  "Africa/Nouakchott": "MR",
  "Africa/Ouagadougou": "BF",
  "Africa/Porto-Novo": "BJ",
  "Africa/Sao_Tome": "ST",
  "Africa/Timbuktu": "ML",
  "Africa/Tripoli": "ML",
  "Africa/Tunis": "TN",
  "Africa/Windhoek": "NA",
  "America/Adak": "US",
  "America/Anchorage": "US",
  "America/Anguilla": "AI",
  "America/Antigua": "AG",
  "America/Araguaina": "BR",
  "America/Argentina/Buenos_Aires": "AR",
  "America/Argentina/Catamarca": "AR",
  "America/Argentina/ComodRivadavia": "AR",
  "America/Argentina/Cordoba": "AR",
  "America/Argentina/Jujuy": "AR",
  "America/Argentina/La_Rioja": "AR",
  "America/Argentina/Mendoza": "AR",
  "America/Argentina/Rio_Gallegos": "AR",
  "America/Argentina/Salta": "AR",
  "America/Argentina/San_Juan": "AR",
  "America/Argentina/San_Luis": "AR",
  "America/Argentina/Tucuman": "AR",
  "America/Argentina/Ushuaia": "AR",
  "America/Aruba": "AW",
  "America/Asuncion": "PY",
  "America/Atikokan": "CA",
  "America/Atka": "US",
  "America/Bahia": "BR",
  "America/Bahia_Banderas": "MX",
  "America/Barbados": "BB",
  "America/Belem": "BR",
  "America/Belize": "BZ",
  "America/Blanc-Sablon": "CA",
  "America/Boa_Vista": "CV",
  "America/Bogota": "CO",
  "America/Boise": "US",
  "America/Buenos_Aires": "AR",
  "America/Cambridge_Bay": "CA",
  "America/Campo_Grande": "BR",
  "America/Cancun": "MX",
  "America/Caracas": "VE",
  "America/Catamarca": "AR",
  "America/Cayenne": "GF",
  "America/Cayman": "KY",
  "America/Chicago": "US",
  "America/Chihuahua": "MX",
  "America/Coral_Harbour": "CA",
  "America/Cordoba": "AR",
  "America/Costa_Rica": "CR",
  "America/Creston": "CA",
  "America/Cuiaba": "BR",
  "America/Curacao": "CW",
  "America/Danmarkshavn": "GL",
  "America/Dawson": "CA",
  "America/Dawson_Creek": "CA",
  "America/Denver": "US",
  "America/Detroit": "US",
  "America/Dominica": "DM",
  "America/Edmonton": "CA",
  "America/Eirunepe": "BR",
  "America/El_Salvador": "SV",
  "America/Ensenada": "MX",
  "America/Fort_Nelson": "CA",
  "America/Fort_Wayne": "US",
  "America/Fortaleza": "BR",
  "America/Glace_Bay": "PE",
  "America/Godthab": "GL",
  "America/Goose_Bay": "CA",
  "America/Grand_Turk": "TC",
  "America/Grenada": "GD",
  "America/Guadeloupe": "BL",
  "America/Guatemala": "GT",
  "America/Guayaquil": "EC",
  "America/Guyana": "GY",
  "America/Halifax": "CA",
  "America/Havana": "CU",
  "America/Hermosillo": "MX",
  "America/Indiana/Indianapolis": "US",
  "America/Indiana/Knox": "US",
  "America/Indiana/Marengo": "US",
  "America/Indiana/Petersburg": "US",
  "America/Indiana/Tell_City": "US",
  "America/Indiana/Vevay": "US",
  "America/Indiana/Vincennes": "US",
  "America/Indiana/Winamac": "US",
  "America/Indianapolis": "US",
  "America/Inuvik": "CA",
  "America/Iqaluit": "CA",
  "America/Jamaica": "JM",
  "America/Jujuy": "AR",
  "America/Juneau": "US",
  "America/Kentucky/Louisville": "US",
  "America/Kentucky/Monticello": "US",
  "America/Knox_IN": "US",
  "America/Kralendijk": "BQ",
  "America/La_Paz": "BO",
  "America/Lima": "PE",
  "America/Los_Angeles": "US",
  "America/Louisville": "US",
  "America/Lower_Princes": "SX",
  "America/Maceio": "BR",
  "America/Managua": "NI",
  "America/Manaus": "BR",
  "America/Marigot": "BL",
  "America/Martinique": "MQ",
  "America/Matamoros": "MX",
  "America/Mazatlan": "MX",
  "America/Mendoza": "AR",
  "America/Menominee": "US",
  "America/Merida": "MX",
  "America/Metlakatla": "US",
  "America/Mexico_City": "MX",
  "America/Miquelon": "PM",
  "America/Moncton": "CA",
  "America/Monterrey": "MX",
  "America/Montevideo": "UY",
  "America/Montreal": "CA",
  "America/Montserrat": "MS",
  "America/Nassau": "BS",
  "America/New_York": "US",
  "America/Nipigon": "CA",
  "America/Nome": "US",
  "America/Noronha": "BR",
  "America/North_Dakota/Beulah": "US",
  "America/North_Dakota/Center": "US",
  "America/North_Dakota/New_Salem": "US",
  "America/Ojinaga": "MX",
  "America/Panama": "PA",
  "America/Pangnirtung": "CA",
  "America/Paramaribo": "SR",
  "America/Phoenix": "US",
  "America/Port-au-Prince": "HT",
  "America/Port_of_Spain": "TT",
  "America/Porto_Acre": "BR",
  "America/Porto_Velho": "BR",
  "America/Puerto_Rico": "PR",
  "America/Punta_Arenas": "CL",
  "America/Rainy_River": "CA",
  "America/Rankin_Inlet": "CA",
  "America/Recife": "BR",
  "America/Regina": "CA",
  "America/Resolute": "CA",
  "America/Rio_Branco": "BR",
  "America/Rosario": "AR",
  "America/Santa_Isabel": "PR",
  "America/Santarem": "BR",
  "America/Santiago": "CL",
  "America/Santo_Domingo": "DO",
  "America/Sao_Paulo": "BR",
  "America/Scoresbysund": "GL",
  "America/Shiprock": "US",
  "America/Sitka": "US",
  "America/St_Barthelemy": "BL",
  "America/St_Johns": "CA",
  "America/St_Kitts": "KN",
  "America/St_Lucia": "LC",
  "America/St_Thomas": "VI",
  "America/St_Vincent": "VC",
  "America/Swift_Current": "CA",
  "America/Tegucigalpa": "HN",
  "America/Thunder_Bay": "CA",
  "America/Tijuana": "MX",
  "America/Toronto": "CA",
  "America/Tortola": "VG",
  "America/Vancouver": "CA",
  "America/Virgin": "US",
  "America/Whitehorse": "CA",
  "America/Winnipeg": "CA",
  "America/Yakutat": "US",
  "America/Yellowknife": "CA",
  "Antarctica/Casey": "NF",
  "Antarctica/Davis": "NF",
  "Antarctica/DumontDUrville": "NF",
  "Antarctica/Macquarie": "NF",
  "Antarctica/Mawson": "NF",
  "Antarctica/McMurdo": "NF",
  "Antarctica/Palmer": "NF",
  "Antarctica/Rothera": "NF",
  "Antarctica/South_Pole": "NF",
  "Antarctica/Syowa": "NF",
  "Antarctica/Troll": "NF",
  "Antarctica/Vostok": "NF",
  "Arctic/Longyearbyen": "NO",
  "Asia/Aden": "YE",
  "Asia/Almaty": "KZ",
  "Asia/Amman": "JO",
  "Asia/Anadyr": "JO",
  "Asia/Aqtau": "KZ",
  "Asia/Aqtobe": "KZ",
  "Asia/Ashgabat": "TM",
  "Asia/Ashkhabad": "TM",
  "Asia/Atyrau": "KZ",
  "Asia/Baghdad": "IQ",
  "Asia/Bahrain": "BH",
  "Asia/Baku": "AZ",
  "Asia/Bangkok": "TH",
  "Asia/Barnaul": "RU",
  "Asia/Beirut": "LB",
  "Asia/Bishkek": "KG",
  "Asia/Brunei": "BN",
  "Asia/Calcutta": "IN",
  "Asia/Chita": "RU",
  "Asia/Choibalsan": "MN",
  "Asia/Chongqing": "CN",
  "Asia/Chungking": "CN",
  "Asia/Colombo": "LK",
  "Asia/Dacca": "BD",
  "Asia/Damascus": "SY",
  "Asia/Dhaka": "BD",
  "Asia/Dili": "TL",
  "Asia/Dubai": "AE",
  "Asia/Dushanbe": "TJ",
  "Asia/Famagusta": "CY",
  "Asia/Gaza": "PS",
  "Asia/Harbin": "CN",
  "Asia/Hebron": "PS",
  "Asia/Ho_Chi_Minh": "VN",
  "Asia/Hong_Kong": "HK",
  "Asia/Hovd": "MN",
  "Asia/Irkutsk": "RU",
  "Asia/Istanbul": "TR",
  "Asia/Jakarta": "ID",
  "Asia/Jayapura": "ID",
  "Asia/Jerusalem": "IL",
  "Asia/Kabul": "AF",
  "Asia/Kamchatka": "RU",
  "Asia/Karachi": "PK",
  "Asia/Kashgar": "CN",
  "Asia/Kathmandu": "NP",
  "Asia/Katmandu": "NP",
  "Asia/Khandyga": "RU",
  "Asia/Kolkata": "IN",
  "Asia/Krasnoyarsk": "RU",
  "Asia/Kuala_Lumpur": "MY",
  "Asia/Kuching": "MY",
  "Asia/Kuwait": "KW",
  "Asia/Macao": "MO",
  "Asia/Macau": "MO",
  "Asia/Magadan": "RU",
  "Asia/Makassar": "ID",
  "Asia/Manila": "PH",
  "Asia/Muscat": "OM",
  "Asia/Nicosia": "CY",
  "Asia/Novokuznetsk": "RU",
  "Asia/Novosibirsk": "RU",
  "Asia/Omsk": "RU",
  "Asia/Oral": "KZ",
  "Asia/Phnom_Penh": "KH",
  "Asia/Pontianak": "ID",
  "Asia/Pyongyang": "KP",
  "Asia/Qatar": "QA",
  "Asia/Qyzylorda": "KZ",
  "Asia/Rangoon": "MM",
  "Asia/Riyadh": "SA",
  "Asia/Saigon": "VN",
  "Asia/Sakhalin": "RU",
  "Asia/Samarkand": "UZ",
  "Asia/Seoul": "KR",
  "Asia/Shanghai": "CN",
  "Asia/Singapore": "SG",
  "Asia/Srednekolymsk": "RU",
  "Asia/Taipei": "TW",
  "Asia/Tashkent": "UZ",
  "Asia/Tbilisi": "GE",
  "Asia/Tehran": "IR",
  "Asia/Tel_Aviv": "IL",
  "Asia/Thimbu": "BT",
  "Asia/Thimphu": "BT",
  "Asia/Tokyo": "JP",
  "Asia/Tomsk": "RU",
  "Asia/Ujung_Pandang": "ID",
  "Asia/Ulaanbaatar": "MN",
  "Asia/Ulan_Bator": "MN",
  "Asia/Urumqi": "CN",
  "Asia/Ust-Nera": "RU",
  "Asia/Vientiane": "LA",
  "Asia/Vladivostok": "RU",
  "Asia/Yakutsk": "RU",
  "Asia/Yangon": "MM",
  "Asia/Yekaterinburg": "RU",
  "Asia/Yerevan": "AM",
  "Atlantic/Azores": "PT",
  "Atlantic/Bermuda": "BM",
  "Atlantic/Canary": "ES",
  "Atlantic/Cape_Verde": "CV",
  "Atlantic/Faeroe": "FO",
  "Atlantic/Faroe": "FO",
  "Atlantic/Jan_Mayen": "NO",
  "Atlantic/Madeira": "PT",
  "Atlantic/Reykjavik": "IS",
  "Atlantic/South_Georgia": "FK",
  "Atlantic/St_Helena": "SH",
  "Atlantic/Stanley": "FK",
  "Australia/ACT": "AU",
  "Australia/Adelaide": "AU",
  "Australia/Brisbane": "AU",
  "Australia/Broken_Hill": "AU",
  "Australia/Canberra": "AU",
  "Australia/Currie": "AU",
  "Australia/Darwin": "AU",
  "Australia/Eucla": "AU",
  "Australia/Hobart": "AU",
  "Australia/LHI": "AU",
  "Australia/Lindeman": "AU",
  "Australia/Lord_Howe": "AU",
  "Australia/Melbourne": "AU",
  "Australia/NSW": "AU",
  "Australia/North": "AU",
  "Australia/Perth": "AU",
  "Australia/Queensland": "AU",
  "Australia/South": "AU",
  "Australia/Sydney": "AU",
  "Australia/Tasmania": "AU",
  "Australia/Victoria": "AU",
  "Australia/West": "AU",
  "Australia/Yancowinna": "AU",
  "Brazil/Acre": "BR",
  "Brazil/DeNoronha": "BR",
  "Brazil/East": "BR",
  "Brazil/West": "BR",
  "Canada/Atlantic": "CA",
  "Canada/Central": "CA",
  "Canada/Eastern": "CA",
  "Canada/Mountain": "CA",
  "Canada/Newfoundland": "CA",
  "Canada/Pacific": "CA",
  "Canada/Saskatchewan": "CA",
  "Canada/Yukon": "CA",
  "Chile/Continental": "CL",
  "Chile/EasterIsland": "CL",
  "Cuba": "CU",
  "Egypt": "EG",
  "Eire": "IE",
  "Europe/Amsterdam": "NL",
  "Europe/Andorra": "AD",
  "Europe/Astrakhan": "RU",
  "Europe/Athens": "GR",
  "Europe/Belfast": "GB",
  "Europe/Belgrade": "RS",
  "Europe/Berlin": "DE",
  "Europe/Bratislava": "SK",
  "Europe/Brussels": "BE",
  "Europe/Bucharest": "RO",
  "Europe/Budapest": "HU",
  "Europe/Busingen": "DE",
  "Europe/Chisinau": "MD",
  "Europe/Copenhagen": "DK",
  "Europe/Dublin": "IE",
  "Europe/Gibraltar": "GI",
  "Europe/Guernsey": "GB",
  "Europe/Helsinki": "AX",
  "Europe/Isle_of_Man": "GB",
  "Europe/Istanbul": "EH",
  "Europe/Jersey": "GB",
  "Europe/Kaliningrad": "RU",
  "Europe/Kiev": "UA",
  "Europe/Kirov": "RU",
  "Europe/Lisbon": "PT",
  "Europe/Ljubljana": "SI",
  "Europe/London": "GB",
  "Europe/Luxembourg": "LU",
  "Europe/Madrid": "ES",
  "Europe/Malta": "MT",
  "Europe/Mariehamn": "AX",
  "Europe/Minsk": "BY",
  "Europe/Monaco": "MC",
  "Europe/Moscow": "RU",
  "Europe/Nicosia": "CY",
  "Europe/Oslo": "NO",
  "Europe/Paris": "FR",
  "Europe/Podgorica": "ME",
  "Europe/Prague": "CZ",
  "Europe/Riga": "LV",
  "Europe/Rome": "IT",
  "Europe/Samara": "RU",
  "Europe/San_Marino": "SM",
  "Europe/Sarajevo": "BA",
  "Europe/Saratov": "RU",
  "Europe/Simferopol": "UA",
  "Europe/Skopje": "MK",
  "Europe/Sofia": "BG",
  "Europe/Stockholm": "SE",
  "Europe/Tallinn": "EE",
  "Europe/Tirane": "AL",
  "Europe/Tiraspol": "MD",
  "Europe/Ulyanovsk": "RU",
  "Europe/Uzhgorod": "UA",
  "Europe/Vaduz": "LI",
  "Europe/Vatican": "VA",
  "Europe/Vienna": "AT",
  "Europe/Vilnius": "LT",
  "Europe/Volgograd": "RU",
  "Europe/Warsaw": "PL",
  "Europe/Zagreb": "HR",
  "Europe/Zaporozhye": "UA",
  "Europe/Zurich": "CH",
  "Hongkong": "HK",
  "Iceland": "IS",
  "Indian/Antananarivo": "MG",
  "Indian/Chagos": "IO",
  "Indian/Christmas": "CX",
  "Indian/Cocos": "CC",
  "Indian/Comoro": "KM",
  "Indian/Kerguelen": "TF",
  "Indian/Mahe": "IN",
  "Indian/Maldives": "MV",
  "Indian/Mauritius": "MU",
  "Indian/Mayotte": "YT",
  "Indian/Reunion": "RE",
  "Iran": "IR",
  "Israel": "IL",
  "Jamaica": "JM",
  "Japan": "JP",
  "Kwajalein": "MH",
  "Libya": "LY",
  "Mexico/BajaNorte": "MX",
  "Mexico/BajaSur": "MX",
  "Mexico/General": "MX",
  "Pacific/Apia": "WS",
  "Pacific/Auckland": "NZ",
  "Pacific/Bougainville": "PG",
  "Pacific/Chatham": "NZ",
  "Pacific/Chuuk": "FM",
  "Pacific/Easter": "CL",
  "Pacific/Efate": "VU",
  "Pacific/Enderbury": "KI",
  "Pacific/Fakaofo": "NZ",
  "Pacific/Fiji": "FJ",
  "Pacific/Funafuti": "TV",
  "Pacific/Galapagos": "EC",
  "Pacific/Gambier": "PF",
  "Pacific/Guadalcanal": "SB",
  "Pacific/Guam": "GU",
  "Pacific/Honolulu": "US",
  "Pacific/Johnston": "US",
  "Pacific/Kiritimati": "KI",
  "Pacific/Kosrae": "FM",
  "Pacific/Kwajalein": "MH",
  "Pacific/Majuro": "MH",
  "Pacific/Marquesas": "PF",
  "Pacific/Midway": "US",
  "Pacific/Nauru": "NR",
  "Pacific/Niue": "NU",
  "Pacific/Norfolk": "NF",
  "Pacific/Noumea": "NC",
  "Pacific/Pago_Pago": "AS",
  "Pacific/Palau": "PW",
  "Pacific/Pitcairn": "NZ",
  "Pacific/Pohnpei": "FM",
  "Pacific/Ponape": "FM",
  "Pacific/Port_Moresby": "PG",
  "Pacific/Rarotonga": "CK",
  "Pacific/Saipan": "MP",
  "Pacific/Samoa": "WS",
  "Pacific/Tahiti": "PF",
  "Pacific/Tarawa": "KI",
  "Pacific/Tongatapu": "TO",
  "Pacific/Truk": "FM",
  "Pacific/Wake": "US",
  "Pacific/Wallis": "WF",
  "Pacific/Yap": "FM",
  "Poland": "PL",
  "Portugal": "PT",
  "Singapore": "SG",
  "Turkey": "TR",
  "US/Alaska": "US",
  "US/Aleutian": "US",
  "US/Arizona": "US",
  "US/Central": "US",
  "US/East-Indiana": "US",
  "US/Eastern": "US",
  "US/Hawaii": "US",
  "US/Indiana-Starke": "US",
  "US/Michigan": "US",
  "US/Mountain": "US",
  "US/Pacific": "US",
  "US/Pacific-New": "US",
  "US/Samoa": "US"
}

export const MOMENT_LOCALES = {
  "ar": "ar",
  "zh": "zh-cn",
  "cs": "cs",
  "nl": "nl",
  "en": "en-au",
  "fr": "fr",
  "de": "de",
  "de_informal": "de",
  "el": "el",
  "iw": "he",
  "hu": "hu",
  "it": "it",
  "ja": "ja",
  "ko": "ko",
  "fa": "fa",
  "pl": "pl",
  "pt": "pt",
  "ro": "ro",
  "ru": "ru",
  "es": "es",
  "sv": "sv",
  "tr": "tr",
  "vi": "vi",
  "id": "id",
  "nn": "nb",
  "sl": "sl",
}

export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const DEFAULT_TIME_REQUEST_BUTTON_LABEL = "Request another time"
export const DEFAULT_TIME_REQUEST_TEXT = "Please let us know the reason why you need another time. Your booking will be subject to approval and you will be notified when your appointment is approved."
